import { useEffect, useRef, useContext } from "react";
import { AuthContext } from "../services/context";
import { getCurrentWorkspace } from "../services/userConfig";
import { useGetEvent } from "../api/event";
import { useLanguage } from "../services/LanguageContext";

/**
 * Hook to fetch event data and update language context
 * This hook monitors the current event ID and updates the language
 * context when the event changes
 */
export const useEventLanguage = () => {
  const { user } = useContext(AuthContext);
  const { updateEvent } = useLanguage();
  const currentWorkspace = getCurrentWorkspace(user);
  const eventId = currentWorkspace?.eventId;
  const lastEventIdRef = useRef(null);

  const { data: event, isLoading } = useGetEvent(eventId);

  // Sync the language context only when the event itself changes. Reacting to
  // the event's language too would fight a manual language change (the form's
  // language picker, the profile selector): updateEvent -> setLanguage ->
  // refetch -> updateEvent -> ... ping-ponging the UI. Defaulting the language
  // from the event is a once-per-event concern.
  useEffect(() => {
    if (!event || event.id !== eventId) return;
    if (eventId === lastEventIdRef.current) return;

    lastEventIdRef.current = eventId;
    updateEvent(event);
  }, [event, updateEvent, eventId]);

  return { event, isLoading };
};
